<template>
  <PrizeBannerModal
    :tracking="{ topicKey: 'lottery-prize-modal' }"
    :visible-jackpot="jackpot"
    v-bind="{ error, headline }"
    @close="emit('close')"
  >
    <EditorPrizeModalContent v-bind="{ config, lotteryId }" />
  </PrizeBannerModal>
</template>

<script lang="ts" setup>
import type { LotteryId } from '#api/shared/@types/generated/backend/graphql-schema-types'

import type { Config } from '../@types/editor'

type Emits = {
  (e: 'close'): void
}

type Props = {
  config: Config
  error: boolean
  headline: string
  jackpot?: Money
  lotteryId: LotteryId
}

const emit = defineEmits<Emits>()

defineProps<Props>()
</script>
